module.exports = __webpack_public_path__ + "c3c39c0befa1b98548d530c561e553c3.MP3";